import {
  CloseOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { useMemo } from 'react';

import { NPage } from '@app/components/Page/types/Page.main';

import type { FC } from 'react';

interface MenuButtonProps {
  menuSidebarState: NPage.MenuSidebarState;
  isMobile?: boolean;
  onClick?: () => void;
}

export const MenuButton: FC<MenuButtonProps> = ({
  menuSidebarState,
  isMobile,
  onClick,
}) => {
  const Icon = useMemo(() => {
    if (isMobile) {
      return menuSidebarState === NPage.MenuSidebarState.NONE
        ? MenuUnfoldOutlined
        : CloseOutlined;
    }

    switch (menuSidebarState) {
      case NPage.MenuSidebarState.NONE:
        return MenuUnfoldOutlined;

      default:
        return MenuFoldOutlined;
    }
  }, [menuSidebarState, isMobile]);

  return (
    <Button
      type="text"
      icon={<Icon />}
      onClick={onClick}
      style={{ fontSize: '18px', width: 36, height: 36 }}
    />
  );
};
